module.exports = __webpack_public_path__ + "static/img/ANTI-BACTERIAL PU products discription1_deskstop.c036e3d7.jpg";